import { OnInit } from '@angular/core';
import { EventsService } from '../../core/services/events-service/events.service';
import { Alert } from '../../shared';
import * as moment from 'moment';
var RegistrationClosingWarningComponent = /** @class */ (function () {
    function RegistrationClosingWarningComponent(eventService) {
        this.eventService = eventService;
        this.formName = '';
    }
    Object.defineProperty(RegistrationClosingWarningComponent.prototype, "date", {
        get: function () {
            var date = this.eventService.getDeadline(this.formName);
            return moment(date);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegistrationClosingWarningComponent.prototype, "dateString", {
        get: function () {
            return this.date.format('dddd MMMM Do, YYYY');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegistrationClosingWarningComponent.prototype, "daysLeft", {
        get: function () {
            var eventTime = this.date.unix();
            var currentTime = moment().unix();
            var diffTime = eventTime - currentTime;
            var duration = moment.duration(diffTime * 1000, 'milliseconds');
            return duration.asDays();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegistrationClosingWarningComponent.prototype, "contextClass", {
        get: function () {
            if (this.daysLeft < 3) {
                return 'warning';
            }
            else {
                return 'info';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegistrationClosingWarningComponent.prototype, "showAlert", {
        get: function () {
            return this.daysLeft < 7;
        },
        enumerable: true,
        configurable: true
    });
    RegistrationClosingWarningComponent.prototype.ngOnInit = function () {
        this.alert = {
            message: 'The deadline for this registration form is ' + this.dateString,
            contextClass: this.contextClass,
        };
    };
    return RegistrationClosingWarningComponent;
}());
export { RegistrationClosingWarningComponent };
